import AsyncMultiSelectSearch from './async-multi-select-search';
export default AsyncMultiSelectSearch;
